import { Form } from "antd";
import React from "react";
import {
  validateFormula,
  ZFormulaArgsInfo,
} from "src/common/attrEdit/components/formula/common";
import { ZUid } from "src/types/zUid";
import { FormulaTemplateInput2 } from "../../formula/FormulaTemplateInput";
import { loadFormulaArguments } from "../../formula/loadFormulaArguments";
import { edCompField } from "../ParamsEditorInfo2";
import { Addon, Precision } from "./common";

interface Props {
  objectId: ZUid;
}

export const FormulaEdProps: React.FC<Props> = ({ objectId }) => {
  const [formulaArgsInfo, setFormulaArgsInfo] =
    React.useState<ZFormulaArgsInfo>();
  const init = async () => {
    setFormulaArgsInfo(await loadFormulaArguments(objectId));
  };

  React.useEffect(() => {
    init();
  }, []);

  return (
    <>
      <Form.Item
        label="Формула"
        name={edCompField("formula")}
        rules={[
          validateFormula(objectId, formulaArgsInfo?.availableAttributes || []),
        ]}
      >
        <FormulaTemplateInput2
          name={edCompField("formula")}
          objectId={objectId}
          attrsList={formulaArgsInfo?.availableAttributes || []}
        />
      </Form.Item>
      <Precision />
      <Addon />
    </>
  );
};
